import { render, staticRenderFns } from "./FlagAlertModal.vue?vue&type=template&id=615d04cc&scoped=true&"
import script from "./FlagAlertModal.vue?vue&type=script&lang=js&"
export * from "./FlagAlertModal.vue?vue&type=script&lang=js&"
import style0 from "./FlagAlertModal.vue?vue&type=style&index=0&id=615d04cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615d04cc",
  null
  
)

export default component.exports